import React, { useContext } from 'react'
import { Box } from '@mui/material'
import { DatePickerContext } from '../DatePickerProvider'
import Field from './Field'
import { HeaderContainer } from './styles'
import { useTranslation } from 'react-i18next'

export default function Header() {
  const { t } = useTranslation()
  const {
    setDateNameSelected,
    dateNameSelected,
    defaultStartDate,
    defaultEndDate,
    singleDateMode,
    editMode
  } = useContext(DatePickerContext)

  if (singleDateMode) {
    return (
      <HeaderContainer>
        <Field
          label={t('ui_elements.form_date')}
          name="startDate"
          defaultValue={defaultStartDate}
          focus={true}
          onFocus={() => {
            setDateNameSelected('startDate')
          }}
        />
      </HeaderContainer>
    )
  }

  return (
    <HeaderContainer>
      <Field
        label={t('ui_elements.form_start_date')}
        name="startDate"
        defaultValue={defaultStartDate}
        focus={dateNameSelected === 'startDate'}
        disabled={editMode}
        onFocus={() => {
          if (!editMode) {
            setDateNameSelected('startDate')
          }
        }}
      />
      <Box sx={{ 
        color: 'text.body.tertiary', 
        display: 'flex', 
        alignItems: 'center',
        paddingTop: '6px',
        flexShrink: 0
      }}>
        <i className="fa-light fa-arrow-right" />
      </Box>
      <Field
        label={t('ui_elements.form_end_date')}
        name="endDate"
        defaultValue={defaultEndDate}
        focus={editMode || dateNameSelected === 'endDate'}
        onFocus={() => {
          setDateNameSelected('endDate')
        }}
      />
    </HeaderContainer>
  )
}
